import type { Variants } from "framer-motion"

export const flashVariants: Variants = {
	hidden: { opacity: 0 },
	visible: { opacity: 1, transition: { duration: 0.2 } },
	exit: { opacity: 0, transition: { duration: 0.2 } },
}

export const fadeInDownVariants: Variants = {
	hidden: { opacity: 0, y: -10 },
	visible: { opacity: 1, y: 0, transition: { duration: 0.3 } },
	exit: { opacity: 0, y: -10, transition: { duration: 0.2 } },
}

export const fadeOutVariants: Variants = {
	hidden: { opacity: 0 },
	visible: { opacity: 1 },
	exit: {
		opacity: 0,
		transition: {
			delay: 2,
			duration: 5,
		},
	},
}

export const pulseVariants: Variants = {
	pulse: {
		scale: [1, 1.1, 1],
		transition: {
			duration: 1.5,
			repeat: Number.POSITIVE_INFINITY,
			repeatType: "loop",
		},
	},
}

export const fadeInVariants: Variants = {
	hidden: { opacity: 0, y: 20 },
	visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
}

export const arrowVariants: Variants = {
	animate: {
		x: [0, 5, 0],
		transition: {
			duration: 1.5,
			repeat: Number.POSITIVE_INFINITY,
			repeatType: "loop",
		},
	},
}

export const dotVariants: Variants = {
	inactive: { scale: 1 },
	active: {
		scale: 1.2,
		transition: { duration: 0.3 },
	},
}

export const floatVariants: Variants = {
	float: {
		y: [0, -10, 0],
		transition: {
			duration: 3,
			repeat: Number.POSITIVE_INFINITY,
			repeatType: "loop",
		},
	},
}

export const containerVariants = {
	hidden: { opacity: 0 },
	visible: {
		opacity: 1,
		transition: {
			when: "beforeChildren",
			staggerChildren: 0.1,
			duration: 0.3,
		},
	},
}

export const itemVariants = {
	hidden: { opacity: 0, y: 20 },
	visible: {
		opacity: 1,
		y: 0,
		transition: {
			type: "spring",
			stiffness: 300,
			damping: 24,
		},
	},
}

export const cardVariants = {
	hidden: { opacity: 0, scale: 0.96 },
	visible: {
		opacity: 1,
		scale: 1,
		transition: {
			type: "spring",
			stiffness: 300,
			damping: 25,
			duration: 0.4,
		},
	},
}
